import React from 'react';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import { ColDef } from 'ag-grid-community';
import MetricCell from 'src/components/BeaconV2Components/MetricCell/MetricCell';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import ProductCell from 'src/components/BeaconV2Components/ProductCell/ProductCell';
import { calculatePercentChange } from 'src/utils/app';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';
import { useMetricFormatter } from 'src/utils/Hooks';

const fields: Field[] = [
  {
    name: 'retailSales'
  },
  {
    name: 'unitsSold'
  }
];

/**
 * Shows the units sold by product for the sales page
 */
const BeaconProWaterfallUnitsSoldTable = () => {
  const formatMetric = useMetricFormatter();

  const columnDefinitions: ColDef[] = [
    {
      headerName: 'Products',
      valueFormatter: (_, row) => <ProductCell stacklineSku={row.stacklineSku} title={row.name} />
    },
    {
      headerName: 'Retail Sales (Current)',
      valueFormatter: (_, row) => <MetricCell value={row.retailSales.value} metricType={METRICTYPE.MONEY} />
    },
    {
      headerName: 'Retail Sales (Prior)',
      valueFormatter: (_, row) => (
        <MetricCell value={row.retailSales.value - row.retailSales.difference} metricType={METRICTYPE.MONEY} />
      )
    },
    {
      headerName: 'Retail Sales (Change)',
      valueFormatter: (_, row) => (
        <MetricCell
          value={row.retailSales.difference}
          metricType={METRICTYPE.MONEY}
          percentChange={calculatePercentChange(
            row.retailSales.value,
            row.retailSales.value - row.retailSales.difference
          )}
        />
      )
    },
    {
      headerName: 'Units Sold (Current)',
      valueFormatter: (_, row) => <MetricCell value={row.unitsSold.value} metricType={METRICTYPE.VOLUME} />
    },
    {
      headerName: 'Units Sold (Prior)',
      valueFormatter: (_, row) => (
        <MetricCell value={row.unitsSold.value - row.unitsSold.difference} metricType={METRICTYPE.VOLUME} />
      )
    },
    {
      headerName: 'Units Sold (Change)',
      valueFormatter: (_, row) => (
        <MetricCell
          value={row.unitsSold.difference}
          metricType={METRICTYPE.VOLUME}
          percentChange={calculatePercentChange(row.unitsSold.value, row.unitsSold.value - row.unitsSold.difference)}
        />
      )
    }
  ];

  return (
    <ProductListContainer
      entityTableHeaderProps={{
        title: 'Units Sold (Current)'
      }}
      indexName={BEACON_INDEX_NAMES.SALES}
      sortFieldName="unitsSold"
      productGridProps={{
        mainMetricOverride: (_, row) => { 
          return (
          `${formatMetric(row.unitsSold.value, METRICTYPE.VOLUME, {
            showFullValue: false,
            decimalPlaces: 1,
            showNegative: true
          })}`
        );
      }
      }}
      fields={fields}
      columnDefinitions={columnDefinitions}
    />
  );
};

export default BeaconProWaterfallUnitsSoldTable;
